import { zodResolver } from "@hookform/resolvers/zod";
import SearchIcon from "@mui/icons-material/Search";
import { Grid, TextField, Typography } from "@mui/material";
import { t } from "i18next";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useCustomersShortData } from "../../../services/customersService";
import BasicDialog from "../../base/BasicDialog";
import { ClientSearchTable } from "./ClientSearchTable";

const searchClientFormSchema = z.object({
    name: z.string().optional(),
    surname: z.string().optional(),
    email: z.string().optional(),
    phone: z.string().optional(),
    company_short_name: z.string().optional(),
});

export function SearchOtherClientDialog(props) {
    const { register, watch } = useForm({
        resolver: zodResolver(searchClientFormSchema),
        defaultValues: {
            name: props.defaultValues?.name || "",
            surname: props.defaultValues?.surname || "",
            email: props.defaultValues?.email || "",
            phone: props.defaultValues?.phone || "",
            company_short_name: props.defaultValues?.company_short_name || "",
        },
    });

    const searchParams = watch();
    const { data: customers } = useCustomersShortData(
        new URLSearchParams({
            page_size:100,
            fname: searchParams.name || "",
            lname: searchParams.surname || "",
            email: searchParams.email || "",
            phone: searchParams.phone || "",
            company_short_name: searchParams.company_short_name || "",
            or_search: "true",
            ...props.defaultSearchParams
        }),
        {
            enabled:
                !!searchParams.name ||
                !!searchParams.surname ||
                !!searchParams.email ||
                !!searchParams.phone ||
                !!searchParams.company_short_name,
        },
    );

    const filteredCustomers =
        customers?.results?.filter(
            (customer) => !props.excludedCustomerIds?.includes(customer.id),
        ) || [];

    return (
        <BasicDialog
            open={props.open}
            onClose={props.onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={props.title}
            maxWidth={"md"}
            showDialogActions
            titleSx={{
                pb: 0,
            }}
            headerComponent={
                <Typography
                    variant={"subtitle1"}
                    sx={{ color: "text.secondary", mx: "auto", mb: 1 }}
                >
                    {t("clients.search.instructions")}
                </Typography>
            }
        >
            <Grid container direction={"column"}>
                <Grid container direction={"row"} gap={1}>
                    {/* <Grid item xs>
                        <TextField
                            {...register("name")}
                            size="small"
                            label={t("clients.fields.firstName")}
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ color: "text.secondary" }} />,
                            }}
                        />
                    </Grid> */}
                    <Grid item xs>
                        <TextField
                            {...register("surname")}
                            size="small"
                            label={t("clients.fields.lastName")}
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ color: "text.secondary" }} />,
                            }}
                        />
                    </Grid>
                    {props.includeCompany && (
                        <Grid item xs>
                            <TextField
                                {...register("company_short_name")}
                                size="small"
                                label={t("CustomerSelectionFormControl.table.companyName")}
                                InputProps={{
                                    endAdornment: <SearchIcon sx={{ color: "text.secondary" }} />,
                                }}
                            />
                        </Grid>
                    )}
                    <Grid item xs>
                        <TextField
                            {...register("email")}
                            size="small"
                            label={t("clients.fields.email")}
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ color: "text.secondary" }} />,
                            }}
                        />
                    </Grid>
                    <Grid item xs>
                        <TextField
                            {...register("phone")}
                            size="small"
                            label={t("clients.fields.phone")}
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ color: "text.secondary" }} />,
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid
                    item
                    sx={{
                        p: 2,
                        py: 3,
                        bgcolor: "whitesmoke",
                        mt: 2,
                        borderRadius: 2,
                    }}
                >
                    <ClientSearchTable
                        clientId={props.clientId}
                        sx={{
                            borderRadius: 2,
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderColor: "ButtonFace",
                        }}
                        data={filteredCustomers}
                        onCustomerSelected={props.onCustomerSelected}
                        includeCompany={props.includeCompany}
                    />
                </Grid>
            </Grid>
        </BasicDialog>
    );
}
